{
  "Sign In - EventLive": "Connexion - EventLive",
  "Forgot Password - EventLive": "Mot de passe oublié - EventLive",
  "Password Restore Link Sent - EventLive": "Lien de réinitialisation envoyé - EventLive",
  "Event": "Événement",
  "Event Details": "Détails de l’événement",
  "Details": "Détails",
  "How to Go Live": "Comment passer en direct",
  "Multi-Camera": "Multicaméra",
  "Add a room": "Ajouter une salle",
  "Guest List": "Liste d’invités",
  "Import Guests": "Importer des invités",
  "Add a Guest": "Ajouter un invité",
  "Event Analytics": "Statistiques de l’événement",
  "Purchase Successful": "Achat réussi",
  "Test EventLive": "Tester EventLive",
  "Schedule Event": "Programmer un événement",
  "Download everything": "Tout télécharger",
  "Update Email": "Modifier l’adresse e-mail",
  "Help Us Grow": "Aidez-nous à grandir",
  "Set a New Password - EventLive": "Nouveau mot de passe - EventLive",
  "Are you sure?": "Voulez-vous continuer ?",
  "Could not load data. Please check your internet connection. Ensure the timezone, date and time on your device are correct.": "Impossible de charger les données. Vérifiez votre connexion Internet et assurez-vous que le fuseau horaire, la date et l’heure de votre appareil sont corrects.",
  "Couldn't save your profile": "Impossible d’enregistrer votre profil",
  "Link required": "Lien obligatoire",
  "Overview": "Aperçu",
  "{days}-Day Event: {start} – {end}": "Événement sur {days} jours : {start} – {end}",
  "Close event": "Fermer l’événement",
  "This sign-in link has expired": "Ce lien de connexion a expiré",
  "Couldn't sign you in from this link": "Impossible de vous connecter avec ce lien",
  "Please sign in to continue.": "Veuillez vous connecter pour continuer.",
  "Couldn't save your changes": "Impossible d’enregistrer vos modifications",
  "TEST": "TEST",
  "Download EventLive for Mac": "Télécharger EventLive pour Mac",
  "Download for": "Télécharger pour",
  "People": "Personnes",
  "Team invite - EventLive": "Invitation à l’équipe - EventLive"
}
